import React, { memo } from 'react';

import EyeHidden from '../../assets/eye-hidden.svg';

export default memo(props => (
  <EyeHidden alt="eye-hidden" data-testid="eye-hidden-icon" {...props} />
));
